
import React from 'react';
import { useLanguage } from '@/components/i18n/language-provider';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const ComparisonCTA = () => {
  const { t } = useLanguage();

  return (
    <Card className="my-16 bg-gradient-to-br from-primary/10 to-primary/5 border-primary/20">
      <CardContent className="p-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold mb-4">
            {t('How does Keystle compare to other solutions?')}
          </h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-3xl mx-auto">
            {t('See how Keystle stands out from Auth0 and Keycloak with our feature-by-feature comparison.')}
          </p>
          <Link 
            to="/comparison" 
            className="inline-flex items-center px-6 py-3 rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            {t('View Comparison')}
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </div>
      </CardContent>
    </Card>
  );
};

export default ComparisonCTA;
